if (!customElements.get('chocolat-restock')) {
  customElements.define('chocolat-restock', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('form').addEventListener('submit', async event => {
        event.preventDefault();
        const form = event.currentTarget;
        if (!form.reportValidity() || this.busy) return;
        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('[role="status"]');
        const data = new FormData(form);
        this.busy = true; button.disabled = true;
        status.textContent = 'Anfrage wird gesendet …';
        try {
          const response = await fetch(this.dataset.endpoint, {
            method:'POST', headers:{'Content-Type':'application/json'},
            body:JSON.stringify({handle:this.dataset.handle,variant:this.dataset.variant,email:data.get('email'),website:data.get('website'),consent:data.has('consent')}),
            signal:AbortSignal.timeout(15000),
          });
          const result = await response.json();
          if (!response.ok) {
            const messages = {not_eligible:'Diese Variante nimmt derzeit keine Verfügbarkeitsanfragen an. Bitte lade die Seite neu.',rate_limited:'Bitte versuche es morgen erneut.',invalid_email:'Bitte prüfe deine E-Mail-Adresse.'};
            throw new Error(messages[result.error] || 'Die Anfrage konnte nicht bestätigt werden. Bitte prüfe dein Postfach, bevor du es später erneut versuchst.');
          }
          status.textContent = 'Bitte bestätige die Anfrage über den Link in deinem E-Mail-Postfach. Eine bereits vorgemerkte Adresse erhält keine weitere Bestätigung.';
          form.querySelector('.chocolat-restock__fields').hidden = true;
          form.querySelector('.chocolat-restock__consent').hidden = true;
          form.querySelector('label[for]').hidden = true;
        } catch (error) {
          status.textContent = error.name === 'TimeoutError' ? 'Die Rückmeldung dauert länger. Bitte prüfe zuerst dein E-Mail-Postfach.' : error.message;
        } finally { this.busy = false; button.disabled = false; }
      });
    }
  });
}
